import { CONFIG } from "@/config";

// Reads utm_source / utm_medium / utm_campaign from the page URL
export function getUtm() {
  const params = new URLSearchParams(window.location.search);
  return {
    utm_source: params.get("utm_source") || "",
    utm_medium: params.get("utm_medium") || "",
    utm_campaign: params.get("utm_campaign") || "",
  };
}

// Short unique id like VS-LX3K9A-7Q2F, stored only in memory for this visit
export function newLeadId() {
  const t = Date.now().toString(36).slice(-6);
  const r = Math.random().toString(36).slice(2, 6);
  return `VS-${t}-${r}`.toUpperCase();
}

// Posts JSON as text/plain so the browser skips the CORS preflight Apps Script cannot answer
export async function postToSheet(payload) {
  // Until the Apps Script URL is pasted in, skip the save so viewers are not shown an error
  if (!/^https:\/\//.test(CONFIG.APPS_SCRIPT_URL)) {
    console.warn("APPS_SCRIPT_URL is not set in config.js, nothing was saved:", payload);
    return { ok: true, skipped: true };
  }
  const res = await fetch(CONFIG.APPS_SCRIPT_URL, {
    method: "POST",
    headers: { "Content-Type": "text/plain;charset=utf-8" },
    body: JSON.stringify(payload),
  });
  const data = await res.json();
  if (!data || data.ok !== true) throw new Error((data && data.error) || "Save failed");
  return data;
}
